export class TermsAndConditions {
  typeCode: string;
  isAccepted: boolean;

  constructor(typeCode: string, isAccepted: boolean) {
    this.typeCode = typeCode;
    this.isAccepted = isAccepted;
  }
}
